<div class="rounded-image-root">
  <img
    [ngClass]="{small, xsmall, xxsmall}"
    [src]="src || 'assets/icons/account_circle_outline.svg'"
    [alt]="alt || 'standard icon'" />
</div>
